import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footerSec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="footer-contact wow fadeInUp" data-wow-duration="2s">
                                    <div className="footer-logo">
                                        <img src="images/logo.png" alt="img" />
                                    </div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliq
                                        ua Ut enim ad minim veniam.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12">
                                <div className="foot-links products  wow fadeInDown" data-wow-duration="2s">
                                    <h5>Quick Links</h5>
                                    <ul className="f-nav">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/about">About</Link></li>
                                        <li><Link to="/products">Products</Link></li>
                                        <li><Link to="/reviews">Reviews</Link></li>
                                        <li><Link to="/contact">Contact Us</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <div className="foot-links products link wow fadeInDown" data-wow-duration="2s">
                                    <h5>Products</h5>
                                    <ul className="f-nav">
                                        <li><Link to="/products">Pens</Link></li>
                                        <li><Link to="/products">Gift Boxes </Link></li>
                                        <li><Link to="/products">Stickers</Link></li>
                                        <li><Link to="/products">Mugs </Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="foot-links contact-us wow fadeInUp" data-wow-duration="2s">
                                    <h5>CONTACT INFO</h5>
                                    <ul className="f-contact">
                                        <li>
                                            <i className="far fa-map-marker-alt" aria-hidden="true" />
                                            <p>Lorem ipsum dolor sit ame  ipsum </p>
                                        </li>
                                        <li>
                                            <Link to="mailto:Lorum@ipsum.com">
                                                <i className="far fa-envelope" aria-hidden="true" />
                                                <p> Lorum@ipsum.com</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="tel:+1231234567890">
                                                <i className="far fa-phone-alt" aria-hidden="true" />
                                                <p>+(123)123-456-7890</p>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-btm ">
                        <div className="container">
                            <div className="row" style={{ alignItems: 'center' }}>
                                <div className="col-lg-4 col-md-4 col-12">
                                    <div className="copy-txt-socail-link wow fadeInLeft" data-wow-duration="2s">
                                        <ul className="d.flex">
                                            <li><Link to="#"><i className="fab fa-facebook-f" aria-hidden="true" /></Link></li>
                                            <li><Link to="#"><i className="fab fa-twitter" /></Link></li>
                                            <li><Link to="#"><i className="fab fa-linkedin-in" /></Link></li>
                                            <li><Link to="#"><i className="fab fa-instagram" /></Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-12">
                                    <div className="copy-txt-all-right wow fadeInRight" data-wow-duration="2s">
                                        <p>© 2025Lorum Ipsum, All Rights Reserved.</p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-12">
                                    <div className="copy-card-atm wow fadeInRight" data-wow-duration="2s">
                                        <img src="images/copy-card-atm-img.png" alt="img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer